var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupervise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121.7 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "growing-market-analysis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.24,57.68V76.41a.87.87,0,0,1-.86.86H25a.87.87,0,0,1-.86-.86V57.68ZM53.62,0A53.62,53.62,0,0,1,98.49,83l23.21,25.29-16,14.63L83.32,98.26A53.62,53.62,0,1,1,53.62,0ZM87.3,19.93a47.64,47.64,0,1,0,14,33.69,47.48,47.48,0,0,0-14-33.69ZM24.12,51.56,43.69,34.44C48,38.68,52.22,43.81,56.5,48.05l15.63-15.7-5-5,14.82-.13v15L77.09,37.3C73.62,40.81,65.43,48.55,62,52c-4.38,4.38-6.47,4.46-10.86.08l-7.4-8.25L35,51.56ZM77.92,47V76.41a.87.87,0,0,1-.86.86H69.65a.86.86,0,0,1-.85-.86V54.12l4.73-4.57L77,46.17a6,6,0,0,0,.89.78ZM63,59.32V76.41a.86.86,0,0,1-.85.86H54.76a.86.86,0,0,1-.85-.86V61.15A11.23,11.23,0,0,0,63,59.32ZM48.13,57.93V76.41a.86.86,0,0,1-.86.86h-7.4a.87.87,0,0,1-.86-.86v-20a4.94,4.94,0,0,0,.44-.36l3.7-3.28,3,3.32.23.24q.9.9,1.77,1.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervise);
export default __webpack_public_path__ + "static/media/supervise.6c905856871d421e8cda20e4288de9f9.svg";
export { ForwardRef as ReactComponent };